module.exports = __webpack_public_path__ + "fonts/deposit-detail-guide-2-KVND.a032d59ds.png";